/*
  Ajax cart
*/

(function () {
  // Root
  const ajaxCartRoot = document.querySelector('.ajax-cart');
  if (!ajaxCartRoot) return;

  // Data
  let ajaxCartUrl = ajaxCartRoot.dataset.cartUrl;
  let ajaxCartChangeUrl = ajaxCartRoot.dataset.cartChangeUrl;
  let ajaxCartCountry = ajaxCartRoot.dataset.country;
  let ajaxCartCount = ajaxCartRoot.dataset.cartCount;
  let ajaxCarMoneyFormat = ajaxCartRoot.dataset.moneyFormat;
  let ajaxCartMoneyFormatExample = ajaxCartRoot.dataset.moneyFormatExample;

  // Elements
  const ajaxCartForms = document.querySelectorAll(`form[action^="/cart/add"]:not(.ajax-cart *)`);
  const ajaxCartTriggers = document.querySelectorAll(`[href="${ajaxCartUrl}"]`);
  let ajaxCartClose = ajaxCartRoot.querySelector('.ajax-cart-header__close');
  let ajaxCartUps = ajaxCartRoot.querySelectorAll('.ajax-cart-qs__plus');
  let ajaxCartDowns = ajaxCartRoot.querySelectorAll('.ajax-cart-qs__minus');
  let ajaxCartLove = ajaxCartRoot.querySelector('.ajax-cart-love');
  let ajaxCartLoveAdd = ajaxCartRoot.querySelector('.ajax-cart-love-item__add');
  let ajaxCartLoveClose = ajaxCartRoot.querySelector('.ajax-cart-love-item__close');
  let ajaxCartLoveForm = ajaxCartRoot.querySelector('.ajax-cart-love-form');
  let ajaxCartLoveFormError = ajaxCartRoot.querySelector('.ajax-cart-love-form__error');
  let ajaxCartLoveMethods = ajaxCartRoot.querySelectorAll('[name="ajax-cart-love-method"]');
  let ajaxCartLoveSender = ajaxCartRoot.querySelector('.ajax-cart-love-form__input--sender');

  // Event listeners
  ajaxCartGlobalListeners();
  ajaxCartCartListeners();

  // Helpers
  function ajaxCartGlobalListeners() {
    // Close
    ajaxCartRoot.addEventListener('click', (event) => {
      if (event.target === ajaxCartRoot) closeAjaxCart();
    });

    // Open
    ajaxCartTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        openAjaxCart();
      });
    });

    // Add to cart
    ajaxCartForms.forEach((form) => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();

        const formData = new FormData(form);

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

        if (!response.ok) return;

        await updateAjaxCart();
        setTimeout(() => {
          openAjaxCart();
        }, 10);
      });
    });
  }

  function ajaxCartCartListeners() {
    ajaxCartClose.addEventListener('click', function () {
      closeAjaxCart();
    });

    ajaxCartUps.forEach((el) => {
      el.addEventListener('click', async () => {
        const currentQuantity = Number(el.dataset.quantity);
        const key = el.dataset.key;
        const newQuantity = currentQuantity + 1;

        const res = await fetch(ajaxCartChangeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: key,
            quantity: newQuantity,
          }),
        });

        updateAjaxCart();
      });
    });

    ajaxCartDowns.forEach((el) => {
      el.addEventListener('click', async () => {
        const currentQuantity = Number(el.dataset.quantity);
        const key = el.dataset.key;
        const newQuantity = currentQuantity - 1;
        if (newQuantity === -1) return;

        const res = await fetch(ajaxCartChangeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: key,
            quantity: newQuantity,
          }),
        });

        updateAjaxCart();
      });
    });

    if (
      ajaxCartLoveMethods &&
      ajaxCartLove &&
      ajaxCartLoveAdd &&
      ajaxCartLoveClose &&
      ajaxCartLoveForm &&
      ajaxCartLoveFormError &&
      ajaxCartLoveSender
    ) {
      ajaxCartLoveAdd.addEventListener('click', (e) => {
        ajaxCartLove.classList.add('ajax-cart-love--active');
      });

      ajaxCartLoveClose.addEventListener('click', (e) => {
        ajaxCartLove.classList.remove('ajax-cart-love--active');
      });

      ajaxCartLoveForm.addEventListener('submit', async (e) => {
        e.preventDefault();

        const methodSelector = '.ajax-cart-love [name="ajax-cart-love-method"]:checked';
        const method = ajaxCartRoot.querySelector(methodSelector)?.value || 'send';

        ajaxCartLoveFormError.classList.remove('ajax-cart-love-form__error--active');

        const formData = new FormData(e.target);

        if (method === 'pay') {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
          });

          if (!response.ok) {
            const res = await response.json();
            const errMessage = res?.message || 'Something went wrong';
            ajaxCartLoveFormError.textContent = errMessage;
            ajaxCartLoveFormError.classList.add('ajax-cart-love-form__error--active');
          } else {
            await updateAjaxCart();
          }
        } else {
          const email = formData.get('properties[Recipient email]');
          const sender = formData.get('sender');

          ajaxCartLoveFormError.classList.remove('ajax-cart-love-form__error--active');

          const success = await subscribeToKlaviyoList(email, sender);

          if (success) {
            ajaxCartLoveFormError.textContent = 'A coupon code has been sent!';
            e.target.reset();
          } else {
            ajaxCartLoveFormError.textContent = 'Something went wrong. Please try again.';
          }

          ajaxCartLoveFormError.classList.add('ajax-cart-love-form__error--active');
        }
      });

      ajaxCartLoveMethods.forEach((radio) => {
        radio.addEventListener('change', (e) => {
          if (e.target.value === 'send') {
            ajaxCartLoveSender.classList.add('ajax-cart-love-form__input--active');
          } else {
            ajaxCartLoveSender.classList.remove('ajax-cart-love-form__input--active');
          }
        });
      });
    }
  }

  async function updateAjaxCart() {
    // Request new cart
    const country = ajaxCartRoot.dataset.country;
    const html = await fetch('/?section_id=ajax-cart&country=' + country).then((r) => r.text());

    // Get new box
    const newCart = document.createElement('div');
    newCart.innerHTML = html;
    const newCartRoot = newCart.querySelector('.ajax-cart');
    const newCartBox = newCart.querySelector('.ajax-cart__box');

    // Replace in dom
    const oldCartBox = ajaxCartRoot.querySelector('.ajax-cart__box');
    oldCartBox.replaceWith(newCartBox);

    // Update data
    ajaxCartUrl = newCartRoot.dataset.cartUrl;
    ajaxCartChangeUrl = newCartRoot.dataset.cartChangeUrl;
    ajaxCartCountry = newCartRoot.dataset.country;
    ajaxCartCount = newCartRoot.dataset.cartCount;
    ajaxCarMoneyFormat = newCartRoot.dataset.moneyFormat;
    ajaxCartMoneyFormatExample = newCartRoot.dataset.moneyFormatExample;

    // Update elements
    ajaxCartClose = ajaxCartRoot.querySelector('.ajax-cart-header__close');
    ajaxCartUps = ajaxCartRoot.querySelectorAll('.ajax-cart-qs__plus');
    ajaxCartDowns = ajaxCartRoot.querySelectorAll('.ajax-cart-qs__minus');
    ajaxCartLoveAdd = ajaxCartRoot.querySelector('.ajax-cart-love-item__add');
    ajaxCartLoveClose = ajaxCartRoot.querySelector('.ajax-cart-love-item__close');
    ajaxCartLove = ajaxCartRoot.querySelector('.ajax-cart-love');
    ajaxCartLoveForm = ajaxCartRoot.querySelector('.ajax-cart-love-form');
    ajaxCartLoveFormError = ajaxCartRoot.querySelector('.ajax-cart-love-form__error');
    ajaxCartLoveMethods = ajaxCartRoot.querySelectorAll('[name="ajax-cart-love-method"]');
    ajaxCartLoveSender = ajaxCartRoot.querySelector('.ajax-cart-love-form__input--sender');

    // Add cart event listeners back
    ajaxCartCartListeners();

    // Update page cart counts
    updateAjaxCartCounts();
  }

  function closeAjaxCart() {
    ajaxCartRoot.classList.remove('ajax-cart--active');
  }

  function openAjaxCart() {
    ajaxCartRoot.classList.add('ajax-cart--active');
  }

  function updateAjaxCartCounts() {
    const cartCount = document.querySelectorAll('.cart-count').forEach((el) => {
      el.textContent = ajaxCartCount;
    });
  }

  async function subscribeToKlaviyoList(email, senderName) {
    if (!email) return false;

    const payload = new URLSearchParams();
    payload.append('g', 'VMDL8V'); // List ID
    payload.append('email', email);

    // Custom profile property
    if (senderName) {
      payload.append('sender_name', senderName);
    }

    // Tell Klaviyo this is a custom field
    payload.append('$fields', 'sender_name');

    try {
      const response = await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json',
        },
        body: payload.toString(),
      });

      if (!response.ok) {
        const data = await response.json();
        console.warn('Klaviyo error:', data.message);
        return false;
      }

      return true;
    } catch (error) {
      console.error('Klaviyo subscription error:', error);
      return false;
    }
  }
})();

/*
  Announcement
*/

(function () {
  const section = document.querySelector('.announcement');
  if (!section) return;
  const el = document.querySelector('[data-alia-id]');
  if (!el) return;
  const idString = el.getAttribute('data-alia-id');
  if (!idString) return;

  section.addEventListener('click', function () {
    try {
      window.alia = window.alia || [];
      window.alia.push({
        type: 'open',
        campaignID: Number(idString),
        ignoreTargeting: false,
      });
    } catch (err) {
      console.log(err);
    }
  });
})();

/*
  Header
*/

(function () {
  const header = document.getElementById('js-header');
  const headerHamburger = document.getElementById('js-header-hamburger');
  const headerShopLink = document.querySelector('.header__nav-item--shop');
  const headerShop = document.querySelector('.header-shop');
  const headerShopClose = document.querySelector('.header-shop__close');
  const headerShopMobileClose = document.querySelector('.header-shop__mobile-close');

  if (header && headerHamburger) {
    headerHamburger.addEventListener('click', function (e) {
      header.classList.toggle('header--active');
      headerShop.classList.remove('header-shop--active');
      document.body.classList.toggle('lock-scroll');
    });

    window.addEventListener('scroll', () => {
      const header = document.getElementById('js-header');
      if (!header) return;

      header.classList.toggle('header--sticky', window.scrollY !== 0);
    });
  }

  if (header && headerShop && headerShopClose && headerShopLink) {
    headerShopLink.addEventListener('click', (e) => {
      e.preventDefault();
      headerShop.classList.add('header-shop--active');
    });

    headerShopClose.addEventListener('click', () => {
      headerShop.classList.remove('header-shop--active');
    });

    headerShopMobileClose.addEventListener('click', () => {
      headerShop.classList.remove('header-shop--active');
    });

    headerShop.addEventListener('click', (e) => {
      if (!e.target.closest('.header-shop__box')) {
        headerShop.classList.remove('header-shop--active');
      }
    });
  }
})();

/*
  Footer
*/

document.addEventListener('DOMContentLoaded', function () {
  const footerYearEl = document.getElementById('js-footer-copyright-year');
  if (footerYearEl) footerYearEl.textContent = new Date().getFullYear();
});

/*
  Reel
*/

(function () {
  // Formatting alt text from caption
  function captionToAlt(caption, maxLength = 125) {
    if (!caption) return '';
    const cleaned = caption
      .replace(/[\s\u200B-\u200D\uFEFF]+/g, ' ')                       // collapse ALL whitespace (incl. nbsp, zero-width) to one space
      .replace(/[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE0F}]/gu, '') // strip emoji
      .replace(/[\s\u200B-\u200D\uFEFF]+/g, ' ')                       // re-collapse gaps left by emoji
      .trim();

    if (cleaned.length <= maxLength) return cleaned;
    return cleaned.slice(0, cleaned.lastIndexOf(' ', maxLength - 1)).trim() + '…';
  }

  // Populate reel with Instagram posts
  async function populateReel() {
    const url = 'https://feeds.behold.so/FkGgRzKAJ6fTScwdMVoT';
    const slides = document.querySelectorAll('.reel__slide');

    try {
      const res = await fetch(url);
      const data = await res.json();

      data.posts.forEach((post, index) => {
        let mediaEl;
        const caption = captionToAlt(post.prunedCaption);
        const mediumImage = post?.sizes?.medium?.mediaUrl;

        if (post.mediaType === 'IMAGE') {
          mediaEl = document.createElement('img');
          mediaEl.src = mediumImage || post.mediaUrl;
          mediaEl.alt = caption || 'Instagram post';
        } else if (post.mediaType === 'VIDEO') {
          mediaEl = document.createElement('video');
          mediaEl.autoplay = true;
          mediaEl.loop = true;
          mediaEl.muted = true;
          mediaEl.playsInline = true;
          mediaEl.src = post.mediaUrl;
        }
        
        mediaEl.setAttribute('loading', 'lazy');

        const link = document.createElement('a');
        link.classList.add('reel__photo');
        link.href = post.permalink;
        link.target = '_blank';
        link.setAttribute('aria-label', `View Instagram post ${index + 1}${caption ? `: ${caption}` : ''}`);
        link.setAttribute('data-ct-item', `reel-post-${index + 1}`);
        link.setAttribute('data-ct-position', 'reel');
        link.appendChild(mediaEl);

        slides.forEach((slide) => {
          slide.appendChild(link.cloneNode(true));
        });
      });
    } catch (err) {
      console.log(err);
    }
  }

  populateReel();
})();

document.addEventListener('click', function (e) {
  const target = e.target.closest('[data-ct-item], [data-ct-link]');
  if (!target) return;

  if (target.hasAttribute('data-ct-link')) {
    Shopify.analytics.publish('bl_link_click', {
      link_name: target.getAttribute('data-ct-link'),
      page_url: window.location.href,
      module_name: target.getAttribute('data-ct-position'),
      // Explicitly clear link-specific keys
      button_name: undefined,
    });
  } else {
    Shopify.analytics.publish('bl_button_click', {
      button_name: target.getAttribute('data-ct-item'),
      page_url: window.location.href,
      module_name: target.getAttribute('data-ct-position'),
      // Explicitly clear link-specific keys
      link_name: undefined,
    });
  }
});
